import React from 'react';

const AboutStats = () => {
  const stats = [
    { value: '70', suffix: '+', label: 'Team members' },
    { value: '100', suffix: '+', label: 'Completed projects' },
    { value: '15', suffix: '+', label: 'Years in the business' },
  ];

  return (
    <section className="py-16 sm:py-20 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="font-heading text-5xl sm:text-6xl md:text-7xl font-bold text-slate-900 mb-2">
                {stat.value}
                <span style={{ color: '#2693FF' }}>{stat.suffix}</span>
              </div>
              <p className="text-slate-500 text-base sm:text-lg uppercase tracking-wider font-medium">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutStats;
